function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-490.000000, -57.000000)",
  fill: "#FFA161",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "hint-overlay-arrow",
  d: "M665,66 L628.030247,57.1548116 L635.741997,90.2686894 L665,66 Z M496.871194,182.869625 C505.070926,155.796999 523.820047,132.295253 553.238959,112.338564 C576.064551,96.8545369 603.552839,84.7037834 635.714405,75.8982025 L638.607913,75.1059831 L637.023474,69.3189672 L634.129966,70.1111866 C601.359777,79.0834036 573.269814,91.5001177 549.87066,107.373228 C519.374063,128.060978 499.753311,152.655301 491.128806,181.130375 L490.259182,184.001569 L496.001569,185.740818 L496.871194,182.869625 Z"
})));

function SvgClickHereArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "129px",
    viewBox: "0 0 175 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Line 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickHereArrow);
export default __webpack_public_path__ + "static/media/click-here-arrow.2bde6c62.svg";
export { ForwardRef as ReactComponent };